import { useCallback } from 'react';
import { createGlobalState } from 'react-use';
import { get, unset } from 'lodash';
import { useCurrentValueGetter } from '../../../hooks';

const useDynamicReportChangeStateInner = createGlobalState({});

export const useDynamicReportChangeState = () => {
    const [changeState, setChangeState] = useDynamicReportChangeStateInner();
    const changeStateGetter = useCurrentValueGetter(changeState);
    const setter = useCallback(
        (reportId, value) => {
            setChangeState(prev => ({ ...prev, [reportId]: value }));
        },
        [setChangeState]
    );
    const getter = useCallback(reportId => get(changeStateGetter(), reportId), [changeStateGetter]);
    const unsetter = useCallback(
        reportId =>
            setChangeState(prev => {
                const newState = { ...prev };
                unset(newState, reportId);

                return newState;
            }),
        [setChangeState]
    );

    return [getter, setter, unsetter];
};
